import {markerLayout} from "../layouts/markerLayout";

export const createMarkers = (dataMarkers) => {
	const markers = dataMarkers.map((markerData) => {
		const marker = {
			type: `Feature`,
			id: markerData.id,
			geometry: {
				type: `Point`,
				coordinates: [markerData.latitude, markerData.longitude],
			},
			properties: {
				hrefImage: markerData.icon,
			},
			options: {
				iconLayout: markerLayout(),
			}
		};
		
		return marker;
	});
	
	return markers;
};
